import { render, staticRenderFns } from "./detailedActivity.vue?vue&type=template&id=786e71d5&scoped=true&"
import script from "./detailedActivity.vue?vue&type=script&lang=js&"
export * from "./detailedActivity.vue?vue&type=script&lang=js&"
import style0 from "./detailedActivity.vue?vue&type=style&index=0&id=786e71d5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "786e71d5",
  null
  
)

export default component.exports